module.exports = __webpack_public_path__ + "static/media/arrow-right.7ab34cca.svg";